import { useState } from "react";
import { Box, Typography, Theme, Tabs, Tab } from "@mui/material";

import ContentTypeManager from "./ContentTypeManager/ContentTypeManager";
import CreateContent from "./CreateContent/CreateContent";

const CMSDashboard = () => {
  const [tabValue, setTabValue] = useState(0);
  const [editContentId, setEditContentId] = useState("");

  const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
    setTabValue(newValue);
    setEditContentId("");
  };

  const handleEditClick = (id: string) => {
    setEditContentId(id);
    setTabValue(1);
  };

  return (
    <>
      <Box 
        sx={{ paddingY: 2 }}
        id="cms_dashboard_header"
        data-test-id="cms_dashboard_header"
        aria-label="CMS Dashboard Header"
      >
        <Typography
          variant="h6"
          sx={{
            background: (theme: Theme) =>
              `linear-gradient(45deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            WebkitBackgroundClip: "text",
            WebkitTextFillColor: "transparent",
            fontWeight: "bold",
          }}
          id="cms_dashboard_title"
          data-test-id="cms_dashboard_title"
          aria-label="Content Management"
        >
          Content Management
        </Typography>
      </Box>
      <Box
        id="cms_dashboard_content"
        data-test-id="cms_dashboard_content"
        aria-label="CMS Dashboard Content"
      >
        <Tabs
          value={tabValue}
          onChange={handleTabChange}
          indicatorColor="primary"
          textColor="primary"
          sx={{
            backgroundColor: "#f5f5f5",
            width: "fit-content",
            borderRadius: "4px",
          }}
          id="cms_dashboard_tabs"
          data-test-id="cms_dashboard_tabs"
          aria-label="CMS Navigation Tabs"
        >
          <Tab 
            label="Content Types"
            id="cms_dashboard_tab_content_types"
            data-test-id="cms_dashboard_tab_content_types"
            aria-label="Content Types Tab"
          />
          <Tab
            label={`${
              editContentId.trim() ? "Edit Content" : "Create Content"
            }`}
            id="cms_dashboard_tab_content"
            data-test-id="cms_dashboard_tab_content"
            aria-label={`${editContentId.trim() ? "Edit" : "Create"} Content Tab`}
          />
        </Tabs>
        <Box 
          sx={{ paddingY: "1rem" }}
          id="cms_dashboard_tab_content"
          data-test-id="cms_dashboard_tab_content"
          aria-label="CMS Tab Content"
        >
          {tabValue === 0 && (
            <ContentTypeManager handleEditClick={handleEditClick} />
          )}
          {tabValue === 1 && <CreateContent editContentId={editContentId} />}
        </Box>
      </Box>
    </>
  );
};

export default CMSDashboard;
